<template>
    <layout>
        <div>
            <div class="ext">
                <div class="int">
                </div>
                <div id="app-top" class="cf">
                    <div class="ph3-ns w-70-ns db center">
                        <div><h1 class="f2 black-70">Pedido Confirmado</h1></div>
                        <div class="cf br3 pa4 cconf-alert bg-washed-green ba b--green solid">
                            <div class="fl w-100 w-100-ns" style="overflow-wrap: break-word;">
                                <span class="db f4 fw6 mb4 dark-green">
                                    <span>Seu pedido foi processado com sucesso.</span>
                                </span>
                                <p class="dark-green">
                                    <span>Um e-mail de confirmação foi enviado a você em</span>&nbsp;<strong class="cconf-client-email">{{email}}</strong>&nbsp;<span>com todos os detalhes do pedido.</span>
                                </p>
                                <p class="dark-green">
                                    <span>Seu pagamento está sendo processado, você receberá um e-mail de confirmação.</span>
                                </p>
                            </div>
                            <div class="fr mt4 mt0-ns w-30-ns">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="checkout-confirmation-top">
                </div>
                <div id="app-container" class="cf">
                    <div>
                        <div class="ph3-ns w-70-ns db center">
                            <div class="pt4">
                                <div class="w-100 fl pa2 pl0">
                                    <h2 class="fw4 f3 ma0 lh-copy"><span>Pedido</span>&nbsp;<span id="order-id">{{orderNumber}}</span></h2>
                                    <time class="gray"><span>{{date}}</span></time>
                                    <div v-bind:class="hasBankInvoice ? 'visible' : 'hide'">
                                        <a class="hover-no-underline dib mt5 mb5 dib w-20-l w-100 ba link tc pv3 pv2-l ph3 br2 f6 fw4 mid-gray bg-near-white hover-bg-moon-gray b--light-silver" v-bind:href="invoiceUrl"><span>Imprimir Boleto</span></a>
                                    </div>
                                    <div v-bind:class="hasInstantPaymentQrCode ? 'visible' : 'hide'" style="max-width:350px;">
                                        <div class="PIX__modal-container">
                                            <div class="PIX__timer-body">
                                                <div class="PIX__pix-logo-container">
                                                    <img alt="pix-logo" src="https://master--lavillecasa.myvtex.com/_v/public/assets/v1/published/vtex.pix-payment@0.12.2/public/react/b578357407b9fc1b238c43bda0b9fc6e.png" width="180" height="64">
                                                </div>
                                                <div class="PIX__qrcode-container">
                                                    <img alt="PIX QRCode" class="PIX_qrcode-image" v-bind:src="'data:image;base64,' + instantPaymentQrCodeImage">
                                                </div>
                                                <div class="PIX__code-preview"><input type="text" class="input" v-model="instantPaymentQrCode" /></div>
                                                <div class="PIX__container-info">
                                                    <div class="PIX__container-info-head">Escaneie o código com seu celular</div>
                                                    <div class="PIX__container-info-description">Abra o app do seu banco no celular, escolha Pix e aponte a câmera para o código</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="dib cf w-100 pt4" style="display:none;">
                                    <div class="cconf-address w-100 fl w-third-l mb3 pr2-ns pr0-s pr0-m">
                                        <article class="undefined w-100 fl tl bg-white br1 shadow-00  min-h-14rem">
                                            <div class="pa3 black-80 f6 lh-copy">
                                                <h3 class="mid-gray mt1 mb3 tracked-mega lh-solid ttu f6 tl"><span>Endereço</span></h3>
                                                <div>
                                                    <strong>teste</strong>
                                                    <div class="address-summary address-summary-BRA">
                                                        <span>
                                                            <span class="street">rua</span>
                                                        </span>
                                                        <span>
                                                            <span class="number-delimiter"> </span>
                                                            <span class="number">56789</span>
                                                        </span>
                                                        <span>
                                                            <span class="complement-delimiter">, </span>
                                                            <span class="complement">numero</span>
                                                        </span>
                                                        <br class="line1-delimiter">
                                                        <span>
                                                            <span class="neighborhood">Bairro</span>
                                                            <span class="neighborhood-delimiter-after"> - </span>
                                                        </span>
                                                        <span>
                                                            <span class="city">Cidade</span>
                                                        </span>
                                                        <span>
                                                            <span class="state-delimiter"> - </span>
                                                            <span class="state">UF</span>
                                                        </span>
                                                        <br class="line2-delimiter">
                                                        <span>
                                                            <span class="postalCode">Cep</span>
                                                        </span>
                                                        <br class="line3-delimiter">
                                                        <span class="country">Brasil</span>
                                                    </div>
                                                </div>
                                                <p class="mb0">+5531999999999</p>
                                            </div>
                                        </article>
                                    </div>
                                    <div class="cconf-payment w-100 fl w-third-l mb3 pr2-ns pr0-s pr0-m">
                                        <article class="undefined w-100 fl tl bg-white br1 shadow-00  min-h-14rem">
                                            <div class="pa3 black-80 f6 lh-copy">
                                                <h3 class="mid-gray mt1 mb3 tracked-mega lh-solid ttu f6 tl"><span>Forma de Pagamento</span></h3>
                                                <div class="w-100 overflow-x-hidden">
                                                    <span class="fl dib overflow-hidden mr2" style="width: 29px; height: 22px; margin-top: -1px;">
                                                        <img alt="Customer Credit" src="//io.vtex.com.br/order-placed-ui/3.7.0/a46eec4e6b2c7eb395abbc21cb0c65ae.png" style="max-width: 400px; margin-left: -371.429px;" />
                                                    </span>
                                                    <span>Customer Credit</span>
                                                    <span class="db mt2 mt0-l di-l fr-l">
                                                        <span>R$&nbsp;20,27</span>
                                                        <span class="ml1"><span>à vista</span></span>
                                                    </span>
                                                    <section class="more-info mt2 mb4">
                                                        <button type="button" class="more-info__button more-info__button--closed dt mv2 pl0 bw0 bg-transparent input-reset gray lh-solid f7 fw6">
                                                            <svg class="more-info__icon dtr v-mid mr1" viewBox="0 0 283 283" xmlns="http://www.w3.org/2000/svg">
                                                                <g fill-rule="evenodd">
                                                                    <circle class="more-info__icon__circle" cx="141.5" cy="141.5" r="141.5"></circle>
                                                                    <path class="more-info__icon__symbol" d="M123.98 209.078v-50.58H73V123.58h50.98V73h33.986v50.58h51.112v34.917h-51.112v50.58"></path>
                                                                </g>
                                                            </svg>
                                                            <span class="more-info__text dtr"><span>Informações Adicionais</span></span>
                                                        </button>
                                                        <ul class="more-info__data more-info__data--closed pl0 ma0 transition-opacity-06s transition-max-height-06s list gray overflow-y-hidden">
                                                            <li class="more-info__data__item f7">
                                                                <span class="more-info__data__item__label mr2 fw5">Tid:</span>
                                                                <span class="more-info__data__item__value">{{orderNumber}}</span>
                                                            </li>
                                                            <li class="more-info__data__item f7"><span class="more-info__data__item__label mr2 fw5">ReturnCode:</span><span class="more-info__data__item__value">200</span></li>
                                                            <li class="more-info__data__item f7"><span class="more-info__data__item__label mr2 fw5">Message:</span><span class="more-info__data__item__value">Payment APPROVED by VTEX Customer Credit.</span></li>
                                                            <li class="more-info__data__item f7"><span class="more-info__data__item__label mr2 fw5">authId:</span><span class="more-info__data__item__value">827d0200-4e8c-11ea-a6a4-21d9474c83b8</span></li>
                                                        </ul>
                                                    </section>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                    <div class="cconf-summary w-100 fl w-third-l mb3">
                                        <article class="undefined w-100 fl tl bg-white br1 shadow-00  min-h-14rem">
                                            <div class="pa3 black-80 f6 lh-copy">
                                                <h3 class="mid-gray mt1 mb3 tracked-mega lh-solid ttu f6 tl"><span>Resumo</span></h3>
                                                <div class="cf w-100">
                                                    <div class="dib f6 fw4 gray w-60"><span>Subtotal</span></div>
                                                    <div class="dib f6 fw4 gray w-40 tr"><span>R$&nbsp;14,80</span></div>
                                                    <hr class="bt-0 bb b--light-gray w-100 mb1 mt1">
                                                </div>
                                                <div class="cf w-100">
                                                    <div class="dib f6 fw4 gray w-60"><span>Entrega</span></div>
                                                    <div class="dib f6 fw4 gray w-40 tr"><span>R$&nbsp;5,47</span></div>
                                                    <hr class="bt-0 bb b--light-gray w-100 mb1 mt1" />
                                                </div>
                                                <div class="cf w-100 mb4">
                                                    <div class="dib fl f6 fw5 mid-gray w-50"><span>Total</span></div>
                                                    <div class="dib fr f6 fw5 mid-gray w-50 tr"><span>R$&nbsp;20,27</span></div>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                                <div class="w-100 pv4 fl" style="display:none;">
                                    <div>
                                        <h2 class="f4 mb0 lh-copy"><span>Pacote</span></h2>
                                        <p class="mb0"><span>Entrega estimada para</span>&nbsp;<span>6&nbsp;<span>dias úteis</span></span><span class="dib br2 pv1 ph2 f7 f6-l fw5 black-70 nowrap bg-light-blue ml2">Sedex</span></p>
                                    </div>
                                    <table class="cconf-product-table table w-100 mt4">
                                        <thead>
                                            <tr class="tl"><th class="pa0 w-60 w-50-ns pb2"><span>Produto</span></th><th class="pa0 w-20 pl1 pr1 pb2 dn dtc-ns"><span>Preço</span></th><th class="pa0 w-20 pl1 pr1 pb2"><span>Qtd.</span></th><th class="pa0 w-30 w-20-ns pb2"><span>Total</span></th></tr>
                                        </thead>
                                        <tbody>
                                            <tr class="cconf-product bt b--light-gray"><td class="pa0 pv3 v-mid overflow-hidden"><img class="mw4-ns fl mr3" src="//lavillecasa.vteximg.com.br/arquivos/ids/171192-50-50" alt="Prato fundo orione rocco bormioli"><div class="fl overflow-hidden w-80-ns"><a href="/prato-sopa-orione-bormioli-rocco/p" class="fw7 f6 mb0" target="_blank">Prato fundo orione rocco bormioli</a><span class="f7 gray db">lavillecasa</span></div></td><td class="pa0 pv3 v-mid dn dtc-ns"><span>R$&nbsp;14,80</span></td><td class="pa0 pv3 v-mid">1 un</td><td class="pa0 pv3 v-mid"><span>R$&nbsp;14,80</span></td></tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <a class="cconf-myorders-button hover-no-underline fr dib ml3 mb2 dib w-20-l w-100 ba link tc pv3 pv2-l ph3 br2 f6 fw4 mid-gray bg-near-white hover-bg-moon-gray b--light-silver" href="https://lavillecasa.com.br/account/orders"><span>Ir para meus pedidos</span></a>
                                    <a class="cconf-continue-button hover-no-underline fr dib ml3 mb2 dib w-20-l w-100 ba link tc pv3 pv2-l ph3 br2 f6 fw4 mid-gray bg-near-white hover-bg-moon-gray b--light-silver" href="https://lavillecasa.com.br/"><span>Realizar nova compra</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="checkout-confirmation-bottom">
                </div>
                <div id="checkout-confirmation-footer">
                </div>
            </div>
        </div>
    </layout>
</template>

<style src="@/assets/css/orderplaced-main.min.css" scoped></style>

<script>
    import layout from "@/views/checkout/_layout.vue";


    export default {
        components: {
            layout
        },
        data: () => ({
            orderNumber: '',
            date: '',
            email: '',
            hasBankInvoice: false,
            invoiceUrl: '',
            hasInstantPaymentQrCode: false,
            instantPaymentQrCode: '',
            instantPaymentQrCodeImage: '',
            instantPaymentUrl: '',
        }),
        mounted() {
            document.title = 'Pedido confirmado';
            if (this.$route && this.$route.query && this.$route.query.order) {
                console.log(JSON.parse(this.$route.query.order));
                var order = JSON.parse(this.$route.query.order);
                this.orderNumber = order.orderNumber;
                this.email = order.email;
                this.date = order.date;
                if (typeof order.invoiceUrl !== 'undefined' && order.invoiceUrl.length > 0) {
                    this.invoiceUrl = order.invoiceUrl;
                    this.hasBankInvoice = true;
                }
            }
            else {
                console.log("fail");
            }
        },
        methods: {

        },
        computed: {

        }
    }
</script>

